module.exports = __webpack_public_path__ + "img/review-vital-img.e67a9e1c.png";